import { Box, Card, CardActionArea, CardContent, Typography } from "@mui/material";
import moment from "moment-timezone";
import QRCode from "react-qr-code";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Config } from "../../config/regions";

const BookingDetailsCard = ({ booking, index }) => {
    const queryParams = useSelector(state => state.common.queryParams);
    return (
        <Card sx={{ borderRadius: 3 }} >
            <CardActionArea component={Link} to={`/event/${booking.id}`}>
                <CardContent>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, direction: index % 2 == 0 ? "ltr" : "rtl" }}>
                        <Box>
                            <QRCode value={`${Config.domainUrl}/event/${booking?.id}`} className="h-16 w-16 mx-auto" />
                            <Typography sx={{ fontSize: 14, fontWeight: 'bold', textAlign: "center" }}> {booking.bookingCode}</Typography>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography sx={{ fontSize: 14, fontWeight: 'bold', direction: 'ltr' }} >
                                {moment(booking.startSec * 1000).format("h:mm A,  Do MMMM YYYY")} ({moment.tz(moment.tz.guess()).zoneAbbr()})
                            </Typography>
                            <Typography sx={{ fontSize: 14, }}>
                                {booking.serviceName}
                            </Typography>
                            {queryParams?.orgId ? null :
                                <Typography sx={{ fontSize: 14, }}>
                                    {booking.organizationName}
                                </Typography>
                            }
                            <Typography sx={{ fontSize: 12, fontWeight: 'bold' }}> {booking.status == "UNSPECIFIED" ? "CONFIRMED" : booking.status}</Typography>
                        </Box>
                    </Box>

                </CardContent>
            </CardActionArea>
        </Card >
    )
}

export default BookingDetailsCard;